import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexBasis: 'auto',
    paddingBottom: theme.spacing(2),
  },
  indicator: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingBottom: 1,
    paddingTop: 1,

    '& .title': {
      display: 'flex',
      justifyContent: 'center',
      fontSize: 24,
      fontWeight: theme.typography.fontWeightBold,
    },
    '& .description': {
      display: 'flex',
      justifyContent: 'center',
      fontSize: 13,
      wordBreak: 'break-word',
      width: '150px',
    },
  },
}))

export default useStyles
